import React from "react";
import "../Styles/Privacy.css";
function Privacy() {
  return (
    <div className="privacy">
      <div className="main-privacy">
        <h1
          data-aos="zoom"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          Our Commitment to Privacy
        </h1>
        <p
          data-aos="zoom"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          Your privacy is important to us. To better protect your privacy we
          provide this notice explaining our online information practices and
          the choices you can make about the way your information is collected
          and used. To make this notice easy to find, we make it available on
          our homepage and at every point where personally identifiable
          information may be requested.
        </p>
        <h2
          data-aos="zoom"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          The Information We Collect
        </h2>
        <p
          data-aos="zoom"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          This notice applies to all information collected or submitted on this
          website. On some pages, you can contact us, register for our
          newsletter, and make requests. The types of personal information
          collected at these pages are:
        </p>
        <ul
          data-aos="zoom"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          <li>Name</li>
          <li>Organization</li>
          <li>Phone</li>
          <li>Email address</li>
          <li>City</li>
          <li>State</li>
        </ul>
        <h2
          data-aos="zoom"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          The Way We Use Information
        </h2>
        <ul
          data-aos="zoom"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          <li>
            We use the information you provide about yourself only when
            communicating with you. We do not share this information with
            outside parties except to the extent necessary to complete your
            request.
          </li>
          <li>
            We use the information you provide about others only when
            communicating with them. We do not share this information with
            outside parties except to the extent necessary to complete the
            request.
          </li>
          <li>
            We use return email addresses to answer the email we receive. Such
            addresses are not used for any other purpose and are not shared with
            outside parties.
          </li>
          <li>
            You can register for our newsletter if you would like to receive our
            occasional email newsletter. Information you submit on our website
            will not be used for this purpose unless you register for this
            service.
          </li>
          <li>
            We use non-identifying and aggregate information to better design
            our website and to share with partners and associates. For example,
            we may reveal that X number of individuals visited a certain area on
            our website, or that Y number of men and Z number of women filled
            out our registration form, but we would not disclose anything that
            could be used to identify those individuals.
          </li>
          <li>
            Finally, we never use or share the personally identifiable
            information provided to us online in ways unrelated to the ones
            described above without also providing you an opportunity to opt-out
            or otherwise prohibit such unrelated uses.
          </li>
        </ul>
        <h2
          data-aos="zoom"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          Our Commitment To Data Security
        </h2>
        <p
          data-aos="zoom"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          To prevent unauthorized access, maintain data accuracy, and ensure the
          correct use of information, we have put in place appropriate physical,
          electronic, and managerial procedures to safeguard and secure the
          information we collect online.
        </p>
        <h2
          data-aos="zoom"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          Our Commitment To Children’s Privacy
        </h2>
        <p
          data-aos="zoom"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          Protecting the privacy of the very young is especially important. For
          that reason, we never collect or maintain information at our website
          from those we actually know are under 13, and no part of our website
          is structured to attract anyone under 13.
        </p>
        <h2
          data-aos="zoom"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          How You Can Access Or Correct Your Information
        </h2>
        <ul
          data-aos="zoom"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
          <li>
            You can access all your personally identifiable information that we
            collect online and maintain by emailing us. We use this procedure to
            better safeguard your information.
          </li>
          <li>
            You can correct factual errors in your personally identifiable
            information by sending us a request that credibly shows error.
          </li>
          <li>
            To protect your privacy and security, we will also take reasonable
            steps to verify your identity before granting access or making
            corrections.
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Privacy;
